import type { HTMLAttributes, ReactNode } from 'react'

import { cn } from './cn'

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  /** Si true, supprime le padding interne (utile quand on contrôle le contenu). */
  noPadding?: boolean
}

export function Card({
  title,
  subtitle,
  actions,
  noPadding,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-white/10 bg-white/[0.02] shadow-[0_1px_0_0_rgba(255,255,255,0.04)]',
        !noPadding && 'p-4',
        className,
      )}
      {...rest}
    >
      {(title || subtitle || actions) && (
        <header className="mb-3 flex items-start justify-between gap-3">
          <div className="flex flex-col gap-0.5">
            {title ? <h3 className="text-sm font-semibold text-white">{title}</h3> : null}
            {subtitle ? <p className="text-xs text-neutral-400">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </header>
      )}
      {children}
    </div>
  )
}
